
import ClickOutside from 'vue-click-outside'
import { CollapseTransition } from 'vue2-transitions'

export default {
  name: 'AppActionBar',
  components: { CollapseTransition },
  directives: { ClickOutside },
  props: {
    backgroundColor: {
      type: String,
      default: 'green'
    },
    leftText: {
      type: String,
      required: true
    },
    rightText: {
      type: String,
      required: true
    },
    leftList: {
      type: Array,
      required: true
    },
    rightList: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    displayLeftList: false,
    displayRightList: false
  }),
  computed: {
    backgroundClass() {
      const colorMap = {
        green: 'bg-primary',
        red: 'bg-red-600'
      }
      return colorMap[this.backgroundColor]
    }
  },
  methods: {
    selectFilter(name) {
      this.$emit('filterChange', name)
      this.displayRightList = false
    }
  }
}
